import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-calendar",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "w-full es-person-form-div" }
const _hoisted_6 = { class: "row w-full" }
const _hoisted_7 = ["src"]

import { watch, ref } from 'vue';
import { AdminApi, ApiError, CreateUpdatePersonRequest, InstituteLightResponse, PersonLightResponse } from '@/apiGenerate/medserver';
import { useI18n } from 'vue-i18n';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from "@/utils/toast-utils";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import { FilterMatchMode } from '@primevue/core/api';
import SharedService from '@/services/SharedService';
import EsPersonForm from '@/components/form/esPersonForm.vue';
import { PersonWithRoleStatusAdminInstitute, SctLanguageItem } from '@/models/share.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esManageAdmin',
  props: {
    isOpen: { type: Boolean },
    header: {},
    currentInstitute: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const adminApi = new AdminApi(medServerApiConfig);

const { t } = useI18n();
const toast = useToast();

const emits = __emit;

const adminUserList = ref<PersonLightResponse[]>([]);

const personRoleTypes = ref<string[]>(Object.values(PersonWithRoleStatusAdminInstitute) as string[]);

const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});
const loading = ref(true);

const dataTableColumns = [
    { field: 'firstname', header: t('admin.institute.person.table.firstname') },
    { field: 'lastname', header: t('admin.institute.person.table.lastname') },
    { field: 'role', header: t('admin.institute.person.table.role') }
];

const getAdminIntituteData = () => {
  if (props.currentInstitute && props.currentInstitute.id) {
    adminApi.getAdminUserByInstitute({instituteId: props.currentInstitute.id}).then((res: PersonLightResponse[]) => {
        adminUserList.value = res.sort((a, b) => {
            const nameCompare = a.firstname.localeCompare(b.firstname, SctLanguageItem.FrFr, { sensitivity: 'base' });
            
            if (nameCompare !== 0) {
                return nameCompare;
            }

            return a.lastname.localeCompare(b.lastname, SctLanguageItem.FrFr, { sensitivity: 'base' });
        });

        loading.value = false;
    }).catch((error: ApiError) => {
        if (error.status) {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t(`error.${error.status}`)
            });
        } else {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: t('error.DEFAULT')
            });
        }
    });
  }
}

const confirmFormModal = () => {
  emits('modal-close');
}

const clearFilter = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
};

const confirmPersonForm = (createUpdatePersonRequest: CreateUpdatePersonRequest) => {
    if (!createUpdatePersonRequest.personId) {
        adminApi.addAdminUserInInstitute({instituteId: props.currentInstitute.id, createUpdatePersonRequest: createUpdatePersonRequest}).then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.add'),
                detail:  t('admin.institute.person.add.message.success')
            });
            getAdminIntituteData();
        }).catch((error: ApiError) => {
            if (error.status) {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });
            } else {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t('error.DEFAULT')
                });
            }
            
        });
    }
}

watch(
    () => props.isOpen,
   () => {
    if (props.currentInstitute) {
      getAdminIntituteData();
    }
  }
)


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, {
              header: _unref(t)('admin.institute.person.title', {name: _ctx.currentInstitute.name})
            }, null, 8, ["header"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(EsPersonForm, {
                  personRoleTypes: personRoleTypes.value,
                  specificRoleType: _unref(PersonWithRoleStatusAdminInstitute).HealthPro,
                  onConfirmForm: _cache[0] || (_cache[0] = ($event: any) => (confirmPersonForm($event)))
                }, null, 8, ["personRoleTypes", "specificRoleType"])
              ]),
              _createVNode(_unref(DataTable), {
                filters: filters.value,
                "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((filters).value = $event)),
                dataKey: "id",
                globalFilterFields: ['firstname', 'lastname'],
                loading: loading.value,
                value: adminUserList.value,
                stripedRows: "",
                paginator: "",
                rows: 5,
                class: "w-full"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(IconField), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(InputIcon), null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _unref(SharedService).getIcon('magnifyingglass', false, 'shareIcons'),
                              class: "img-grey"
                            }, null, 8, _hoisted_7)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(InputText), {
                          modelValue: filters.value['global'].value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
                          placeholder: _unref(t)('admin.institute.person.search')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createVNode(_unref(InputIcon), null, {
                          default: _withCtx(() => [
                            _createVNode(_component_es_button_icon, {
                              icon: "xmark",
                              folder: "shareIcons",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter())),
                              styles: "img-grey"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                empty: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.table.empty')), 1)
                ]),
                loading: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('common.loading')), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataTableColumns, (col) => {
                    return _createVNode(_unref(Column), {
                      key: col.field,
                      field: col.field,
                      header: col.header,
                      sortable: ""
                    }, null, 8, ["field", "header"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["filters", "loading", "value"])
            ]),
            _createVNode(_component_es_modal_footer, {
              displayCancel: false,
              confirmLabel: 'action.close',
              confirmModalMethod: () => confirmFormModal()
            }, null, 8, ["confirmModalMethod"])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})